import { FC } from "react";
import { Widget } from "./Widget";
type Props = {
  widgetProps: {
    title: string;
    className?: string;
    subTitle?: string;
  };
  number: number;
  icon: JSX.Element;
};

export const WidgetStatistics: FC<Props> = ({ widgetProps, number, icon }) => {
  return (
    <Widget {...widgetProps}>
      <div className="d-flex align-items-center gap-2 stats-widget">
        <div style={{ height: "40px", width: "40px" }}>{icon}</div>
        <div className="fs-2 fw-bold" style={{ height: "40px" }}>
          {number}
        </div>
      </div>
    </Widget>
  );
};
